//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { ContainerRowSpace,ContainerRowError,ContainerRowTitle,ContainerRowInstructionLink} from '@lesofi/phoenix-react-js'
import DataFormContainer from './DataFormContainer'

const DataExtractionForm = props => {
    const { location } = props;
    const query = queryString.parse(location.search);
    
    if (!query.jwt || !query.docUrl || !query.taskAcceptedInfoId ) {
        return (
            <div className="container">
               <ContainerRowSpace />
               <ContainerRowTitle title={'Form Data Extraction'} />
               <ContainerRowError errorMsg={'Missing Parameters!'} /> 
            </div>
        )
    }
    
    return (
        <div className="container">
            <ContainerRowSpace />
            <ContainerRowTitle title={'Form Data Extraction'} />
            <ContainerRowInstructionLink docLink={query.docUrl} instructionLink={'https://docs.google.com/document/d/e/2PACX-1vSTh1Tk_Oy0Rog-DmeY6fpd68vvDwny8d4nIsujdhEx9ep4rZ56se2dc3egWwo-vJjWB5QruFg1ZUOW/pub?embedded=true'} />
            <DataFormContainer query={query}/>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        kratos: state.kratos
    }
}

export default connect(mapStateToProps)(DataExtractionForm);


// WEBPACK FOOTER //
// ./src/views/ProjectKratos/DataExtractionForm.js